export const TelemetryType = {
    log: 'log',
    configuration: 'configuration',
    usage: 'usage',
};
